import React from "react";
import { BrowserRouter, Routes, Route, Navigate, Outlet, useLocation } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { Shell } from "@/layout/Shell";

import Welcome from "@/pages/Welcome";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import ForgotPassword from "@/pages/ForgotPassword";
import ResetPassword from "@/pages/ResetPassword";
import ChangePassword from "@/pages/ChangePassword";
import Today from "@/pages/Today";
import Journey from "@/pages/Journey";
import Learn from "@/pages/Learn";
import Reader from "@/pages/Reader";
import You from "@/pages/You";
import MonthOverview from "@/pages/MonthOverview";
import Journal from "@/pages/Journal";
import Reference from "@/pages/Reference";
import Cover from "@/pages/Cover";
import Shift from "@/pages/Shift";
import Admin from "@/pages/Admin";

function Loading() {
  return (
    <div className="min-h-screen bg-surface flex items-center justify-center">
      <div className="text-inkfaint text-sm animate-pulse">Opening your journal…</div>
    </div>
  );
}

function RequireAuth() {
  const { user } = useAuth();
  const location = useLocation();
  if (user === undefined) return <Loading />;
  if (user === null) return <Navigate to="/welcome" replace />;
  if (user.must_change_password && location.pathname !== "/change-password") {
    return <Navigate to="/change-password" replace />;
  }
  return <Outlet />;
}

function PublicOnly() {
  const { user } = useAuth();
  if (user === undefined) return <Loading />;
  if (user) return <Navigate to="/" replace />;
  return <Outlet />;
}

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route element={<PublicOnly />}>
            <Route path="/welcome" element={<Welcome />} />
            <Route path="/login" element={<Login />} />
            <Route path="/register" element={<Register />} />
            <Route path="/forgot-password" element={<ForgotPassword />} />
            <Route path="/reset-password" element={<ResetPassword />} />
          </Route>

          <Route element={<RequireAuth />}>
            <Route element={<Shell />}>
              <Route path="/" element={<Today />} />
              <Route path="/journey" element={<Journey />} />
              <Route path="/learn" element={<Learn />} />
              <Route path="/you" element={<You />} />
            </Route>
            <Route element={<Shell sub />}>
              <Route path="/month/:id" element={<MonthOverview />} />
              <Route path="/journal/:id" element={<Journal />} />
              <Route path="/read/:slug" element={<Reader />} />
              <Route path="/reference" element={<Reference />} />
              <Route path="/cover" element={<Cover />} />
              <Route path="/shift" element={<Shift />} />
              <Route path="/change-password" element={<ChangePassword />} />
              <Route path="/admin" element={<Admin />} />
            </Route>
          </Route>

          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="top-center" />
    </AuthProvider>
  );
}

export default App;
